module.exports = __webpack_public_path__ + "mc.a6ed56ab.svg";